import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { fetchArticle } from "@/lib/queries";

/**
 * Detaljesider er fjernet i v2. Gamle URLer 301-redirecter direkte til
 * artiklens oprindelige kilde. Falder tilbage til /artikler hvis kilden
 * mangler eller artiklen ikke findes.
 */
export const Route = createFileRoute("/artikel/$id")({
  loader: async ({ params }) => {
    const article = await fetchArticle(params.id);
    if (!article) throw notFound();
    const target = article.original_url && /^https?:\/\//i.test(article.original_url)
      ? article.original_url
      : "https://flaneriet.online/artikler";
    throw redirect({ href: target, statusCode: 301 });
  },
  head: () => ({
    meta: [
      { title: "Flyttet – Flâneriet" },
      { name: "robots", content: "noindex,follow" },
    ],
  }),
  component: () => null,
});
